export default __webpack_public_path__ + "static/media/HTML.69c3a72b.png";